export const StartAFrUrls = {
  'medical': 'new/crowdfunding/medical',
  'non-medical': 'new/crowdfunding/non-medical',
  'new':'new/saf'
};
